import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import MineralUiCard, {
  CardBlock as MineralUiCardBlock,
  CardTitle as MineralUiCardTitle,
} from 'mineral-ui/Card';
import Spinner from '../Spinner';

// Additional props. Note this will be removed in the future for a skeleton
const propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};
const defaultProps = {
  loading: false,
};

// TODO, eventually use a skeleton instead of spinner for card loading
const SpinnerWrapper = styled.div`
  position: relative;
  min-height: 32px;
`;

// Wrapper for MineralUi card components
// https://mineral-ui.com/components/card
export default class Card extends Component {
  static Block = MineralUiCardBlock;

  static Title = MineralUiCardTitle;

  render() {
    const { children, loading, ...rest } = this.props;
    return (
      <MineralUiCard {...rest}>
        {!loading && children}
        {loading && <SpinnerWrapper><Spinner /></SpinnerWrapper>}
      </MineralUiCard>
    );
  }
}

Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
